export const COLUMNS = [
  {
    key: "invoice_tenant_number",
    label: "Fawter Number",
    filterLabel: "Fawter Number",
    sortable: true,
    searchable: true,
    visible: false,
    visibleSmallScreen: false
  },
  {
    key: "invoice_date",
    label: "Date",
    filterLabel: "Date",
    sortable: true,
    formatter: "formatCellDate",
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_subject",
    label: "Invoice",
    filterLabel: "Invoice",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_merchant_number",
    label: "Invoice Number",
    filterLabel: "Invoice Number",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_status",
    label: "Status",
    filterLabel: "Status",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_customer_name",
    label: "Customer",
    filterLabel: "Customer",
    sortable: true,
    searchable: true,
    visible: false,
    visibleSmallScreen: false
  },
  {
    key: "invoice_due_date",
    label: "Due Date",
    filterLabel: "Due Date",
    sortable: true,
    formatter: "formatCellDate",
    visible: false,
    visibleSmallScreen: false
  },
  {
    key: "invoice_currency_sign",
    label: "Currency",
    filterLabel: "Currency",
    sortable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_total",
    label: "Invoice Total",
    filterLabel: "Invoice Total",
    sortable: true,
    formatter: "formatCurrency",
    visible: true,
    visibleSmallScreen: true,
    total: true
  },
  {
    key: "merchant_fawter_fee",
    label: "Merchant Fawter Fees",
    filterLabel: "Merchant Fawter Fees",
    sortable: true,
    formatter: "formatCurrency",
    visible: true,
    visibleSmallScreen: true,
    total: true,
    customClass: "align-data-end"
  },
  {
    key: "merchant_payment_fee",
    label: "Merchant Payment Fees",
    filterLabel: "Merchant Payment Fees",
    sortable: true,
    formatter: "formatCurrency",
    visible: true,
    visibleSmallScreen: true,
    total: true,
    customClass: "align-data-end"
  },
  {
    key: "merchant_payout",
    label: "Net Payout",
    filterLabel: "Net Payout",
    sortable: true,
    formatter: "formatCurrency",
    visible: true,
    visibleSmallScreen: true,
    total: true,
    customClass: "align-data-end"
  },
  {
    key: "invoice_payment_date",
    label: "Payment Date",
    filterLabel: "Payment Date",
    sortable: true,
    formatter: "formatCellDate",
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_payment_method_name",
    label: "Payment Method",
    filterLabel: "Payment Method",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_offline_payment_option",
    label: "Offline Payment Method",
    filterLabel: "Offline Payment Method",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  }
];
